"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheStore = void 0;
const types_1 = require("./types");
class CacheStore {
    constructor(storage, logger) {
        this.store = storage;
        this.logger = logger;
    }
    getConfigKey(user) {
        return user.isAnonymous ? types_1.StoreKey.AnonymousConfig : types_1.StoreKey.IdentifiedConfig;
    }
    getConfigUserIdKey(user) {
        return `${this.getConfigKey(user)}.user_id`;
    }
    getConfigFetchDateKey(user) {
        return `${this.getConfigKey(user)}.fetch_date`;
    }
    async loadConfigUserId(user) {
        const userIdKey = this.getConfigUserIdKey(user);
        return this.store.load(userIdKey);
    }
    async loadConfigFetchDate(user) {
        const fetchDateKey = this.getConfigFetchDateKey(user);
        const fetchDate = await this.store.load(fetchDateKey) || '0';
        return parseInt(fetchDate, 10);
    }
    saveConfig(data, user, dateFetched) {
        var _a;
        const configKey = this.getConfigKey(user);
        const fetchDateKey = this.getConfigFetchDateKey(user);
        const userIdKey = this.getConfigUserIdKey(user);
        this.store.save(configKey, data);
        this.store.save(fetchDateKey, dateFetched);
        this.store.save(userIdKey, user.user_id);
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.info('Successfully saved config to local storage');
    }
    isBucketedUserConfig(object) {
        if (!object || typeof object !== 'object')
            return false;
        return 'features' in object
            && 'project' in object
            && 'environment' in object
            && 'featureVariationMap' in object
            && 'variableVariationMap' in object
            && 'variables' in object;
    }
    async loadConfig(user, configCacheTTL = 604800000) {
        var _a, _b, _c, _d;
        const userId = await this.loadConfigUserId(user);
        if (user.user_id !== userId) {
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug(`Skipping cached config: no config for user ID ${user.user_id}`);
            return null;
        }
        const cachedFetchDate = await this.loadConfigFetchDate(user);
        const isConfigCacheTTLExpired = Date.now() - cachedFetchDate > configCacheTTL;
        if (isConfigCacheTTLExpired) {
            (_b = this.logger) === null || _b === void 0 ? void 0 : _b.debug('Skipping cached config: last fetched date is too old');
            return null;
        }
        const configKey = await this.getConfigKey(user);
        const config = await this.store.load(configKey);
        if (config === null || config === undefined) {
            (_c = this.logger) === null || _c === void 0 ? void 0 : _c.debug('Skipping cached config: no config found');
            return null;
        }
        if (!this.isBucketedUserConfig(config)) {
            (_d = this.logger) === null || _d === void 0 ? void 0 : _d.debug(`Skipping cached config: invalid config found: ${JSON.stringify(config)}`);
            return null;
        }
        return config;
    }
    saveUser(user) {
        var _a;
        if (!user) {
            throw new Error('No user to save');
        }
        this.store.save(types_1.StoreKey.User, user);
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.info('Successfully saved user to local storage');
    }
    async loadUser() {
        return this.store.load(types_1.StoreKey.User);
    }
    saveAnonUserId(userId) {
        var _a;
        this.store.save(types_1.StoreKey.AnonUserId, userId);
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.info('Successfully saved anonymous user id to local storage');
    }
    async loadAnonUserId() {
        return await this.store.load(types_1.StoreKey.AnonUserId);
    }
    removeAnonUserId() {
        this.store.remove(types_1.StoreKey.AnonUserId);
    }
}
exports.CacheStore = CacheStore;
exports.default = CacheStore;
//# sourceMappingURL=CacheStore.js.map